import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTIONS = gql`
  query campaignOrderTransactions(
    $where: CampaignOrderTransactionsWithEventsWhereInput!
    $first: Int
    $skip: Int
    $orderBy: CampaignOrderTransactionsWithEventsOrderByInput
  ) {
    campaignOrderTransactionsWithEventsesConnection(
      first: $first
      skip: $skip
      orderBy: $orderBy
      where: $where
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          orderId
          totalImpressions
          revenue
          lastImpression
          transactionDate
          attrMethod
          attrValue
          attrWindow
        }
      }
      aggregate {
        count
      }
    }
    full: campaignOrderTransactionsWithEventsesConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTIONS;
